
import { Component, Prop, Vue, Watch, Emit } from "vue-property-decorator";
import Editor5 from "@/components/editor/classic-editor5.vue";
// import UploadImg from "@/components/UploadImg-ai.vue";
import UploadImgBefore from "@/components/UploadImg-ai.vue";
import UploadVideo from "@/components/UploadVideo-ai.vue";
import Pop from "../components/blue-pop.vue";
// import { CompanyConfig } from "@/lib/common/acm";

import { ExamV2Custom, BeforeVideo } from "@/lib/model/exambuilder/exam-v2";
import Auth from "@/lib/common/auth";

enum type {
  "video" = 1,
  "read" = 2,
  "img" = 4,
  "text" = 5
}

@Component({
  components: { UploadVideo, Editor5, UploadImgBefore, Pop }
})
export default class CandidateAnswerSection extends Vue {
  @Prop({ type: ExamV2Custom, default: null }) exam!: ExamV2Custom; //考试Model
  @Prop({ type: Boolean, default: false }) isEdit!: boolean; //是否编辑页面

  chkQuestionIndex(e: number, it: any) {
    e = Number(e) || 0;
    const questionNum =
      this.exam.isRandomQuestions !== 1
        ? this.exam.questionIdList.length
        : this.exam.examRandomConfigList.reduce(
            (a, b) => a + b.questionNumber,
            0
          );
    e = e < 1 ? 1 : e > questionNum ? questionNum : e;
    it.questionIndex = e;
    this.change();
  }

  hideShowWay(it: BeforeVideo) {
    return it.type === 1 ? true : false;
  }
  getTitle(it: BeforeVideo) {
    if (it.type === 1) {
      return "手写签名页";
    }
    return it.showWay === 1
      ? "视频须知页"
      : it.showWay === 2
      ? "虚拟面试官朗读须知页"
      : it.showWay === 4
      ? "图片须知页"
      : "文字须知页";
  }

  type(t: number | string) {
    return type[t];
  }
  changeType(it: BeforeVideo, i: number) {
    if (i === 1) {
      //手写签名
      it.showWay = 5;
      it.buttonText = "同意并签名";
      it.positionType = "beforeDescBefore";
    }
    if (i === 0) {
      //须知信息
      it.showWay = 2;
      it.buttonText = "下一步";
    }
    console.log(this.exam.examVideoList);
    this.change();
  }
  //添加额外须知语
  addBeforeVideo() {
    this.exam.examVideoList.push(new BeforeVideo());
    this.change();
  }
  delBeforeVideo(i: number) {
    this.exam.examVideoList.splice(i, 1);
    this.change();
  }
  @Emit()
  change() {
    return this.exam.examVideoList;
  }
}
